module.exports = {"API_KEY":"AIzaSyD04_28yT_iYiq3x688MSTvIlOeIpcBCLw"}


//////////////////
// WEBPACK FOOTER
// ./api_key.json
// module id = B7P2
// module chunks = 1